module.exports = __webpack_public_path__ + "static/img/3.f504f9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/sp/3.png
// module id = IYou
// module chunks = 0